import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const StyledNetworkStatusBanner = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
    padding: 6px 0px;
    color: ${theme.palette.common.white};
    width: 100%;
    background-color: #ff5630;
    flex-wrap: wrap;
    ${theme.breakpoints.down('sm')} {
      gap: 4px;
    }
    .alert {
      font-size: ${theme.typography.subtitle2.fontSize};
      font-family: ${theme.typography.subtitle2.fontFamily};
      font-weight: ${theme.typography.subtitle2.fontWeightRegular};
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }
    .description {
      font-size: ${theme.typography.captionLight.fontSize};
      font-family: ${theme.typography.captionLight.fontFamily};
      font-weight: ${theme.typography.captionLight.fontWeightRegular};
    }
  `
);
